import { SVGProps } from 'react';

export type AddIconProps = SVGProps<SVGSVGElement> & {
  color?: string;
};

export const AddIcon = ({ color = '#0e0e0e', ...props }: AddIconProps) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.8332 10.8332H10.8332V15.8332H9.1665V10.8332H4.1665V9.1665H9.1665V4.1665H10.8332V9.1665H15.8332V10.8332Z"
      fill={color}
    />
  </svg>
);
